import type { IconProps } from '../types/IconProps.ts';
export const MicOff: IconProps = {
    name: 'MicOff',
    children: [
        `<path d="M9.17 4A3 3 0 0 1 15 5v5M14 14.24A3 3 0 0 1 9 12V9M18.84 13.5q.16-.73.16-1.5v-2M5 10v2a7 7 0 0 0 7 7m4-1.25A7 7 0 0 1 12 19m0 0v3M2 2l20 20" />`,
    ]
};